import { Formik, Form } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useResetPasswordMutation } from "@sso/apis/resetPassword";
import { AuthHeader } from "@sso/components/AuthHeader";
import { FormikPasswordInput } from "@sso/components/Formik";
import { FormikTextInput } from "@sso/components/Formik/FormikTextInput";
import { SubmitLoadingButton } from "@sso/components/SubmitLoadingButton";
import {
  AuthKeys,
  notificationsMsgs,
  PathKeys,
  QueryKeys,
  resetPasswordInitialValues,
  SnackbarKeys,
} from "@sso/constant";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ResetPasswordType } from "@sso/types";

import { resetPasswordValidation } from "./schema";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const key = searchParams.get(QueryKeys.KEY);
  const secret = searchParams.get(QueryKeys.SECRET);

  const handleOnSubmit = ({ password }: ResetPasswordType) => {
    if (!key || !secret) {
      dispatch(pushSnackbar({ type: SnackbarKeys.ERROR, title: notificationsMsgs.WRONG_URL_ADDRESS }));
    } else {
      resetPassword({ password, key, secret })
        .unwrap()
        .then(() => navigate(PathKeys.SIGN_IN));
    }
  };

  return (
    <>
      <AuthHeader title="Reset Password" description="Please choose a new password." />
      <Formik
        initialValues={resetPasswordInitialValues}
        validationSchema={resetPasswordValidation}
        onSubmit={handleOnSubmit}
      >
        <Form>
          <FormikPasswordInput name={AuthKeys.PASSWORD} label="Password" showPasswordStrength />
          <FormikTextInput name={AuthKeys.CONFIRM_PASSWORD} label="Confirm Password" type="password" />
          <SubmitLoadingButton loading={isLoading} buttonTitle="Reset Password" />
        </Form>
      </Formik>
    </>
  );
};
